import { BrushCleaning, Stethoscope, Wrench } from "lucide-react";

const CATEGORY_ICON_BY_SLUG = Object.freeze({
  cleaning: BrushCleaning,
  physio: Stethoscope,
});

const LEGACY_CATEGORY_ALIASES = Object.freeze({
  cleaning: "cleaning",
  reinigung: "cleaning",
  physio: "physio",
});

export const GENERIC_SERVICE_ICON = Wrench;

export function serviceCategorySlug(category = {}) {
  const value = typeof category === "string" ? { slug: category } : (category || {});
  const explicit = value.category_slug || value.service_category_slug || value.slug;
  if (explicit) return String(explicit).trim().toLowerCase();

  const internalId = value.category_id || value.service_category_id || value.id;
  if (String(internalId || "").startsWith("service-category-")) {
    return String(internalId).slice("service-category-".length).toLowerCase();
  }

  // Old schedule projections only exposed the stable catalogue name.
  const legacyName = value.category_name || value.service_category_name || value.name;
  return LEGACY_CATEGORY_ALIASES[String(legacyName || "").trim().toLowerCase()] || "";
}

export function getServiceCategoryIcon(category) {
  return CATEGORY_ICON_BY_SLUG[serviceCategorySlug(category)] || GENERIC_SERVICE_ICON;
}
